import React from 'react';
import c from './newTest.module.css';

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className={c.modalOverlay} onClick={onClose}>
            <div className={c.modalContent} onClick={(e) => e.stopPropagation()}>
                <div className={c.modalBody}>
                    {children}
                </div>
                <div className={c.modalFooter}>
                    <button className={c.modalButton} onClick={onClose}>
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal; 